import {
  SparklesIcon,
  HandRaisedIcon,
  UserGroupIcon,
  FaceSmileIcon,
  ShieldCheckIcon,
  BeakerIcon,
  HeartIcon,
  UserIcon,
  SunIcon,
} from "@heroicons/react/24/outline";

export interface ExpertCategory {
  id: string;
  name: string;
  label: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  description: string;
  color: string;
  apiFilter: string;
}

export const expertCategories: ExpertCategory[] = [
  {
    id: "all",
    name: "All",
    label: "All",
    icon: SparklesIcon,
    description:
      "Explore all our certified wellness experts and instructors across various specializations",
    color: "from-purple-500 to-purple-600",
    apiFilter: "",
  },
  {
    id: "yoga",
    name: "Yoga Instructor",
    label: "Yoga",
    icon: HandRaisedIcon,
    description:
      "Traditional and modern yoga practices including Hatha, Vinyasa, Ashtanga, and Kundalini yoga for all levels",
    color: "from-emerald-500 to-emerald-600",
    apiFilter: "yogaInstructor",
  },
  {
    id: "pranayama",
    name: "Pranayama Coach",
    label: "Pranayama",
    icon: SparklesIcon,
    description:
      "Specialized breathwork techniques for lung health, stress relief, and enhanced vitality through ancient pranayama practices",
    color: "from-cyan-500 to-cyan-600",
    apiFilter: "pranayamaCoach",
  },
  {
    id: "meditation",
    name: "Meditation Coach",
    label: "Meditation",
    icon: SunIcon,
    description:
      "Guided meditation practices for mental clarity, emotional balance, stress reduction, and spiritual growth",
    color: "from-purple-500 to-purple-600",
    apiFilter: "meditationCoach",
  },
  {
    id: "zumba",
    name: "Zumba Instructor",
    label: "Zumba",
    icon: UserGroupIcon,
    description:
      "High-energy dance fitness combining Latin rhythms with easy-to-follow moves for a fun, effective workout",
    color: "from-pink-500 to-pink-600",
    apiFilter: "zumbaInstructor",
  },
  {
    id: "nutrition",
    name: "Nutritionist",
    label: "Nutrition",
    icon: BeakerIcon,
    description:
      "Personalized diet planning, weight management, and nutritional guidance for optimal health and wellness goals",
    color: "from-green-500 to-green-600",
    apiFilter: "nutritionist",
  },
  {
    id: "ayurveda",
    name: "Ayurveda Practitioner",
    label: "Ayurveda",
    icon: SparklesIcon,
    description:
      "Traditional Ayurvedic healing, herbal medicine, detox programs, and holistic wellness based on ancient wisdom",
    color: "from-amber-500 to-amber-600",
    apiFilter: "ayurvedaPractitioner",
  },
  {
    id: "women-wellness",
    name: "Women's Wellness Coach",
    label: "Women's Wellness",
    icon: HeartIcon,
    description:
      "Holistic wellness programs designed specifically for women's health, hormonal balance, and life transitions",
    color: "from-rose-500 to-rose-600",
    apiFilter: "womenWellnessCoach",
  },
  {
    id: "self-defense",
    name: "Self Defense Instructor",
    label: "Self Defense",
    icon: ShieldCheckIcon,
    description:
      "Practical self-defense techniques, martial arts training, and confidence building for personal safety and empowerment",
    color: "from-red-500 to-red-600",
    apiFilter: "selfDefenseInstructor",
  },
];
